// tslint:disable
// this is an auto generated file. This will be overwritten

export const getTask = `query GetTask($id: ID!) {
  getTask(id: $id) {
    id
    title
    description
    status
    assignedTo {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const listTasks = `query ListTasks(
  $filter: ModelTaskFilterInput
  $limit: Int
  $nextToken: String
) {
  listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      status
      assignedTo {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
    }
    nextToken
  }
}
`;
export const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    createdAt
    name
    emailAddress
    contactNumber
    address
    province
    industry
    physicalAddress
    numberOfEmployees
    archived
    interests {
      items {
        id
      }
      nextToken
    }
    suburb
    teamLead {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
    teamMembers {
      items {
        id
      }
      nextToken
    }
    reports {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const listCompanys = `query ListCompanys(
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    nextToken
  }
}
`;
export const getUser = `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    dateOfBirth
    name
    surname
    emailAddress
    contactNumber
    idNumber
    physicalAddress
    archived
    verified
    role
    status
    jobTitle
    company {
      items {
        id
      }
      nextToken
    }
    companyTeamLead {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const listUsers = `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
    nextToken
  }
}
`;
export const getReport = `query GetReport($id: ID!) {
  getReport(id: $id) {
    id
    name
    description
    publisedDate
    price
    documentLocation
    maxDownloads
    downloadable
    status
    province
    suburb
    city
    paidOrFree
    reportDetails
    coverImageUrl
    documentResourceUrl
    tags {
      items {
        id
      }
      nextToken
    }
    categories {
      items {
        id
      }
      nextToken
    }
    reigon {
      items {
        id
      }
      nextToken
    }
    companys {
      items {
        id
      }
      nextToken
    }
    vouchers {
      items {
        id
      }
      nextToken
    }
    transactions {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const listReports = `query ListReports(
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    nextToken
  }
}
`;
export const getReigon = `query GetReigon($id: ID!) {
  getReigon(id: $id) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const listReigons = `query ListReigons(
  $filter: ModelReigonFilterInput
  $limit: Int
  $nextToken: String
) {
  listReigons(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      reports {
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getTag = `query GetTag($id: ID!) {
  getTag(id: $id) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const listTags = `query ListTags($filter: ModelTagFilterInput, $limit: Int, $nextToken: String) {
  listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      reports {
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getCategory = `query GetCategory($id: ID!) {
  getCategory(id: $id) {
    id
    name
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const listCategorys = `query ListCategorys(
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      reports {
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getVoucher = `query GetVoucher($id: ID!) {
  getVoucher(id: $id) {
    id
    name
    code
    discountPercentage
    reports {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const listVouchers = `query ListVouchers(
  $filter: ModelVoucherFilterInput
  $limit: Int
  $nextToken: String
) {
  listVouchers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      code
      discountPercentage
      reports {
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getFaq = `query GetFaq($id: ID!) {
  getFaq(id: $id) {
    id
    title
    question
    answer
    topic
    category
  }
}
`;
export const listFaqs = `query ListFaqs($filter: ModelFaqFilterInput, $limit: Int, $nextToken: String) {
  listFaqs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      question
      answer
      topic
      category
    }
    nextToken
  }
}
`;
export const getInterest = `query GetInterest($id: ID!) {
  getInterest(id: $id) {
    id
    name
    company {
      items {
        id
      }
      nextToken
    }
  }
}
`;
export const listInterests = `query ListInterests(
  $filter: ModelInterestFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterests(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      company {
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getTransaction = `query GetTransaction($id: ID!) {
  getTransaction(id: $id) {
    id
    card {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const listTransactions = `query ListTransactions(
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      card {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
    nextToken
  }
}
`;
export const getCard = `query GetCard($id: ID!) {
  getCard(id: $id) {
    id
    name
    type
    number
    nameOnCard
    expiryDate
    ccv
    purchases {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
  }
}
`;
export const listCards = `query ListCards(
  $filter: ModelCardFilterInput
  $limit: Int
  $nextToken: String
) {
  listCards(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      type
      number
      nameOnCard
      expiryDate
      ccv
      purchases {
        id
        name
        type
        number
        nameOnCard
        expiryDate
        ccv
      }
    }
    nextToken
  }
}
`;
export const getCompanyInterest = `query GetCompanyInterest($id: ID!) {
  getCompanyInterest(id: $id) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    interests {
      id
      name
      company {
        nextToken
      }
    }
  }
}
`;
export const listCompanyInterests = `query ListCompanyInterests(
  $filter: ModelCompanyInterestFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanyInterests(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
      interests {
        id
        name
      }
    }
    nextToken
  }
}
`;
export const getUserCompany = `query GetUserCompany($id: ID!) {
  getUserCompany(id: $id) {
    id
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
    user {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        nextToken
      }
      companyTeamLead {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
  }
}
`;
export const listUserCompanys = `query ListUserCompanys(
  $filter: ModelUserCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
      user {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
    }
    nextToken
  }
}
`;
export const getCompanyReport = `query GetCompanyReport($id: ID!) {
  getCompanyReport(id: $id) {
    id
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    company {
      id
      createdAt
      name
      emailAddress
      contactNumber
      address
      province
      industry
      physicalAddress
      numberOfEmployees
      archived
      interests {
        nextToken
      }
      suburb
      teamLead {
        id
        dateOfBirth
        name
        surname
        emailAddress
        contactNumber
        idNumber
        physicalAddress
        archived
        verified
        role
        status
        jobTitle
      }
      teamMembers {
        nextToken
      }
      reports {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const listCompanyReports = `query ListCompanyReports(
  $filter: ModelCompanyReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanyReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
      company {
        id
        createdAt
        name
        emailAddress
        contactNumber
        address
        province
        industry
        physicalAddress
        numberOfEmployees
        archived
        suburb
      }
    }
    nextToken
  }
}
`;
export const getReportTag = `query GetReportTag($id: ID!) {
  getReportTag(id: $id) {
    id
    tag {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const listReportTags = `query ListReportTags(
  $filter: ModelReportTagFilterInput
  $limit: Int
  $nextToken: String
) {
  listReportTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tag {
        id
        name
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
    }
    nextToken
  }
}
`;
export const getReportCategory = `query GetReportCategory($id: ID!) {
  getReportCategory(id: $id) {
    id
    category {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const listReportCategorys = `query ListReportCategorys(
  $filter: ModelReportCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listReportCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      category {
        id
        name
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
    }
    nextToken
  }
}
`;
export const getReportReigon = `query GetReportReigon($id: ID!) {
  getReportReigon(id: $id) {
    id
    reigon {
      id
      name
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const listReportReigons = `query ListReportReigons(
  $filter: ModelReportReigonFilterInput
  $limit: Int
  $nextToken: String
) {
  listReportReigons(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      reigon {
        id
        name
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
    }
    nextToken
  }
}
`;
export const getReportVoucher = `query GetReportVoucher($id: ID!) {
  getReportVoucher(id: $id) {
    id
    voucher {
      id
      name
      code
      discountPercentage
      reports {
        nextToken
      }
    }
    report {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
  }
}
`;
export const listReportVouchers = `query ListReportVouchers(
  $filter: ModelReportVoucherFilterInput
  $limit: Int
  $nextToken: String
) {
  listReportVouchers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      voucher {
        id
        name
        code
        discountPercentage
      }
      report {
        id
        name
        description
        publisedDate
        price
        documentLocation
        maxDownloads
        downloadable
        status
        province
        suburb
        city
        paidOrFree
        reportDetails
        coverImageUrl
        documentResourceUrl
      }
    }
    nextToken
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.ts